module.exports = __webpack_public_path__ + "img/summit-2.5d3f329e.jpg";